import axios from "axios";
import { destroyCookie, parseCookies } from "nookies";
import { url } from "./constants";

// Create an Axios instance
const axiosInstance = axios.create({
	baseURL: url, // Replace with your API base URL
	timeout: 10000, // Set a timeout if necessary
});

axiosInstance.interceptors.request.use(
	(config) => {
		const { toab_adm } = parseCookies();

		if (toab_adm) {
			config.headers["Authorization"] = `Bearer ${toab_adm}`;
		}

		const fairId =
			(typeof window !== "undefined" &&
				localStorage.getItem("selected_fair_id")) ||
			(axiosInstance.defaults.headers.common["fairid"] as string);

		if (fairId) {
			config.headers["fairid"] = fairId;
			config.headers["fair-id"] = fairId;
		}

		// Return the modified config
		return config;
	},
	(error) => {
		console.error("Request Error:", error.message);
		return Promise.reject(error);
	}
);
// Add a response interceptor
axiosInstance.interceptors.response.use(
	(response) => {
		// If the response is successful, just return it
		return response;
	},
	(error) => {
		// Handle errors globally
		if (error.response) {
			// Server responded with a status code outside 2xx
			const { status, data } = error.response;
			// Handle specific status codes
			switch (status) {
				case 400:
					// console.error('Bad Request:', data?.message || 'Invalid request.');
					break;
				case 401:
					window.location.href = "/login";
					destroyCookie(null, "toab_adm");

					break;
				case 403:
					console.error(
						"Forbidden:",
						data?.message || "Access is denied."
					);
					break;
				case 404:
					console.error(
						"Not Found:",
						data?.message || "Requested resource not found."
					);
					break;
				case 500:
					console.error(
						"Server Error:",
						data?.message || "Internal server error."
					);
					break;
				default:
					console.error(
						"Error:",
						data?.message || "An unknown error occurred."
					);
			}
		} else if (error.request) {
			// Request was made, but no response was received
			console.error("No Response:", "The server did not respond.");
		} else {
			// Something happened while setting up the request
			console.error("Error Setting Up Request:", error.message);
		}
		return Promise.reject(error);
	}
);
export type HTTPResponse<T> = {
	success: boolean;
	message?: string;
	total?: number;
	data: T;
};
// Example: Fetch a User
export type RequestOptions<T> = {
	url: string;
	data?: T; // For `post`, `put`
	params?: Record<string, any>; // For query params
};
export const httpService = {
	get: async <T>({
		url,
		params,
	}: Omit<RequestOptions<void>, "data">): Promise<HTTPResponse<T>> => {
		const response = await axiosInstance.get<HTTPResponse<T>>(url, {
			params,
		});
		return response.data;
	},

	post: async <T, U>({
		url,
		data,
	}: RequestOptions<U>): Promise<HTTPResponse<T>> => {
		const response = await axiosInstance.post<HTTPResponse<T>>(url, data);
		return response.data;
	},
	patch: async <T, U>({
		url,
		data,
	}: RequestOptions<U>): Promise<HTTPResponse<T>> => {
		const response = await axiosInstance.patch<HTTPResponse<T>>(url, data);
		return response.data;
	},

	put: async <T, U>({
		url,
		data,
	}: RequestOptions<U>): Promise<HTTPResponse<T>> => {
		const response = await axiosInstance.put<HTTPResponse<T>>(url, data);
		return response.data;
	},

	delete: async <T>({
		url,
		params,
	}: RequestOptions<null>): Promise<HTTPResponse<T>> => {
		const response = await axiosInstance.delete<HTTPResponse<T>>(url, {
			params,
		});
		return response.data;
	},
};

export default axiosInstance;
